import React, { Fragment } from 'react';
import { AAMBeaconIconButton } from 'components/shared/Beacon';
import { ReactComponent as EditIcon } from 'assets/icons/edit_icon.svg';
import './EditModal.scss';
import { getCostBasisObjects } from 'support/ArrayUtil';

const EditModalDisclosure = ({
  account,
  accountType,
  hasMutualFund,
  setSelectedCostBasis
}) => {
  if (!accountType) return null;
  return (
    <Fragment>
      <div className="cost-basis-edit-icon-v2">
        <AAMBeaconIconButton
          variant="tertiary"
          aria-label={'edit-button'}
          onBeaconEventClick={() => {
            setSelectedCostBasis({
              account,
              accountType,
              hasMutualFund,
              currentCostBasis: getCostBasisObjects(account)
            });

            const modal =
              document.getElementById('cost-basis-edit-modal') ?? null;
            if (modal !== null) modal.show();
          }}>
          <EditIcon slot="icon" />
        </AAMBeaconIconButton>
      </div>
    </Fragment>
  );
};

export default EditModalDisclosure;
